import { CircularProgress, Box, Modal, Button, Typography } from "@mui/material";
import React from "react";
import { ArchiveGroupModalController, ArchiveGroupModalControllerDelegate } from "./controller";

interface State {
  isLoading: boolean;
}

interface Props {
  groupId: string;
  delegate: ArchiveGroupModalDelegate;
}

const boxStyle = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: 600,
  width: "70%",
  bgcolor: 'background.paper',
  border: '2px solid red',
  borderRadius: 4,
  boxShadow: 24,
  p: 4,
};

export interface ArchiveGroupModalDelegate {
  shouldCloseArchiveModal: () => void;
  shouldLogout: () => void;
  genericError: () => void;
  didArchiveGroup: () => void;
}

class ArchiveGroupModal extends React.Component<Props, State> implements ArchiveGroupModalControllerDelegate {
  controller: ArchiveGroupModalController

  constructor(props: Props) {
    super(props);
    this.state = {
      isLoading: false
    }
    this.controller = new ArchiveGroupModalController(this);
  }

  // delegate
  didArchiveGroup(){
    this.props.delegate.didArchiveGroup();
  }

  genericError() {
    this.props.delegate.genericError();
  };

  groupShouldLogout() {
    this.props.delegate.shouldLogout();
  };

  // internals
  didClickDelete() {
    this.setState({isLoading: true});
    const token = localStorage.getItem("AccessToken")!;
    this.controller.archiveGroup(token, this.props.groupId)
  }

  didClickClose() {
    this.props.delegate.shouldCloseArchiveModal();
  }

  renderLoading() {
    return (
      <Box
        alignItems="center"
        display="flex"
        flexDirection="column"
        marginTop={2}
      >
        <CircularProgress />
      </Box>
    );
  }

  renderForm() {
    return (
      <Box
        alignItems="center"
        display="flex"
        flexDirection="column"
        marginTop={2}
      >
        <Typography variant="h3" color="red">
          Confirmar Arquivamento
        </Typography>
        <Typography variant="body1">
          Tem certeza que deseja arquivar esta devolutiva agregada?
        </Typography>
        <Typography variant="body1">
          Você apenas poderá restaurá-la entrando em contato com a administração
        </Typography>
        <Box m={2} display="flex" flexDirection="row" gap={1}>
          <Button
            variant="contained"
            color="error"
            onClick={() => this.didClickDelete()}
          >
              Arquivar Devolutiva Agregada
          </Button>
          <Button
            variant="outlined"
            color="error"
            onClick={() => this.didClickClose()}
          >
            Cancelar
          </Button>
        </Box>
      </Box>
    );
  }

  // Internals
  render() {
    return (
      <Modal
        open
        onClose={() => this.didClickClose()}
      >
        <Box
          sx={boxStyle}
        >
          {this.state.isLoading ? this.renderLoading() : this.renderForm()}
        </Box>
      </Modal>
    );
  }
}

export default ArchiveGroupModal;
